<template src="./MapControlTitle.html"> </template>

<script>
export default {
    name: 'MapControlTitle',
    props: {
        text: {
            required: true,
            type: String,
        }
    }
}
</script>

<style lang="scss" src="./MapControlTitle.scss"></style>